module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dispatchList"
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "position": "absolute",
      "right": "40px",
      "top": "20px",
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "城市",
      "clearable": ""
    },
    on: {
      "change": _vm.selectCity
    },
    model: {
      value: (_vm.searchForm.city),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "city", $$v)
      },
      expression: "searchForm.city"
    }
  }, _vm._l((_vm.pickingCityList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.isSh) ? _c('el-form-item', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "区域",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.countyType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "countyType", $$v)
      },
      expression: "searchForm.countyType"
    }
  }, _vm._l((_vm.pickingAreaList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "订单类型"
    },
    model: {
      value: (_vm.searchForm.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "serviceType", $$v)
      },
      expression: "searchForm.serviceType"
    }
  }, _vm._l((_vm.orderTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "渠道"
    },
    model: {
      value: (_vm.searchForm.orderIdentifier),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "orderIdentifier", $$v)
      },
      expression: "searchForm.orderIdentifier"
    }
  }, _vm._l((_vm.OrderNolList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入地址",
      "maxlength": "50"
    },
    model: {
      value: (_vm.searchForm.address),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.address"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "filterable": "",
      "filter-method": _vm.PinyinMatch,
      "filterable": "",
      "placeholder": "请选择工程师",
      "clearable": ""
    },
    on: {
      "change": _vm.changeEnginner
    },
    model: {
      value: (_vm.searchForm.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "engineerId", $$v)
      },
      expression: "searchForm.engineerId"
    }
  }, _vm._l((_vm.pickingEngineerList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "预约时间"
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: (_vm.valueTime3),
      callback: function($$v) {
        _vm.valueTime3 = $$v
      },
      expression: "valueTime3"
    }
  })], 1), _vm._v(" "), (_vm.valueTime3) ? _c('el-form-item', [_c('el-time-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '9:00',
        step: '01:00',
        end: '21:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '9:00',
        step: '01:00',
        end: '21:00',
        minTime: _vm.startTime
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('searchForm')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearFrom()
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "180",
      "label": "设备详情"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.modelName) + " " + _vm._s(scope.row.colorName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "prop": "totalAp",
      "label": "故障小类"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.faultSubclass), function(item, index) {
          return _c('span', {
            key: index,
            staticStyle: {
              "display": "block"
            }
          }, [_vm._v(_vm._s(item.faultSubclassShortName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "180",
      "label": "预约时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.onsiteDate) + " " + _vm._s(scope.row.onsiteTimeStart) + "~" + _vm._s(scope.row.onsiteTimeEnd))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "align": "center",
      "sortable": "",
      "label": "区域"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.countyName) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "350",
      "align": "center",
      "label": "地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.address) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "center",
      "label": "工程师姓名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.serviceTpe == 'QS' || scope.row.serviceTpe == 'QD') && scope.row.is_fetch == 0) ? _c('span', [_vm._v(_vm._s(scope.row.fetchName))]) : (scope.row.sendMachineWay == 3) ? _c('span', [_vm._v(_vm._s(scope.row.sendMachineEngineer))]) : _c('span', [_vm._v(_vm._s(scope.row.engineerName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "100",
      "label": "订单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.serviceType, 'order_type')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "400",
      "align": "center",
      "prop": "handleRemark",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": "订单渠道"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.orderIdentifier, 'order_identifier')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "center",
      "prop": "sendName",
      "label": "派单员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "180",
      "prop": "orderNo",
      "label": "订单号"
    }
  }), _vm._v(" "), (_vm.basicsAuth.revert_send_orders) ? _c('el-table-column', {
    attrs: {
      "width": "60",
      "align": "center",
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (_vm.basicsAuth.revert_send_orders) ? [(scope.row.adminStatus == '05' || scope.row.adminStatus == '06' || scope.row.adminStatus == '07' || scope.row.adminStatus == '39' || scope.row.adminStatus == '40') ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.newModel(scope.row)
            }
          }
        }, [_vm._v("改派")]) : _vm._e()] : undefined
      }
    }], null, true)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textModelMenu[_vm.dialogModelStatus],
      "visible": _vm.dislogModel,
      "close-on-click-modal": false,
      "width": "700px",
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogModel = $event
      },
      "close": function($event) {
        return _vm.emptyModelDialog('modelForm')
      }
    }
  }, [_c('el-form', {
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm,
      "label-width": "95px",
      "label-position": _vm.labelPosition,
      "rules": _vm.modelFormRules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": "",
      "placeholder": "请输入关联工单"
    },
    model: {
      value: (_vm.modelForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "orderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在区域"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.countyName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "countyName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.countyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约时间"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.time),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "time", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.colorName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "colorName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.colorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已派工程师"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.engineerName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "engineerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.engineerName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在城市"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.cityName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "cityName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.cityName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址详情"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.address),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备详情"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.modelDetail),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelDetail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.modelDetail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障详情",
      "prop": "faultSubclassStr"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.modelForm.faultSubclassStr),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "faultSubclassStr", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.faultSubclassStr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "改派工程师",
      "prop": "engineerId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择改派工程师",
      "filter-method": _vm.PinyinMatch1,
      "clearable": ""
    },
    on: {
      "change": _vm.changeCustomer
    },
    model: {
      value: (_vm.modelForm.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "engineerId", $$v)
      },
      expression: "modelForm.engineerId"
    }
  }, _vm._l((_vm.pickingPointEngineerList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.dialogModelStatus == 'create') ? _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addModelFormSubmitBtn('modelForm')
      }
    }
  }, [_vm._v("确认")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100, 500, 1000],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-701d5f5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dispatchOrder/dispatchList.vue
// module id = 1712
// module chunks = 0